import { useEffect, useState } from 'react'
import axios from 'axios'

const DEFAULT_LAST_UPDATE = 'September 2025'

/**
 * Fetches the database "last update" month/year from the backend.
 * Shared by SearchScreen and DataCenterScreen so both pages always
 * display the exact same value.
 */
function useDatabaseLastUpdate() {
  const [lastUpdateFormatted, setLastUpdateFormatted] = useState(DEFAULT_LAST_UPDATE)

  useEffect(() => {
    let isMounted = true

    const fetchLastUpdate = async () => {
      try {
        const { data } = await axios.get('/api/v1/data/last-update/')
        const raw = data.formatted || data.last_update || ''
        if (!raw || !isMounted) return

        const parsedDate = new Date(raw)
        if (!isNaN(parsedDate)) {
          setLastUpdateFormatted(parsedDate.toLocaleDateString('en-US', { month: 'long', year: 'numeric' }))
        } else {
          // If already a formatted string like "September 26, 2025", strip the day
          const match = raw.match(/([A-Za-z]+)\s+\d+,?\s+(\d{4})/)
          if (match) setLastUpdateFormatted(`${match[1]} ${match[2]}`)
        }
      } catch (error) {
        console.log('Error fetching last update:', error)
      }
    }

    fetchLastUpdate()

    return () => {
      isMounted = false
    }
  }, [])

  return lastUpdateFormatted
}

export default useDatabaseLastUpdate
